document.addEventListener('DOMContentLoaded', function () {
  const selector = document.querySelector('.blanket-warmth-selector');
  if (!selector) return;

  const design = selector.dataset.design;
  const selectedWarmth = selector.dataset.warmth;

  if (!design || !selectedWarmth) return;

  const products = {
    light: {
      bear: 'https://nintarababy.in/products/baby-blankets-the-breezy-blanket-bear-hugs',
      vroom: 'https://nintarababy.in/products/baby-blankets-the-breezy-blanket-vroom-vroom',
      blush: 'https://nintarababy.in/products/baby-blankets-the-breezy-blanket-blush-blossom',
    },
    medium: {
      bear: 'https://nintarababy.in/products/baby-blankets-the-everyday-blanket-bear-hugs',
      vroom: 'https://nintarababy.in/products/the-everyday-blanket-vroom-vroom',
      blush: 'https://nintarababy.in/products/baby-blankets-the-everyday-blanket-blush-blossom',
    },
    warm: {
      bear: 'https://nintarababy.in/products/baby-blankets-little-comforter-bear-hugs',
      vroom: 'https://nintarababy.in/products/baby-blankets-little-comforter-vroom-vroom',
      blush: 'https://nintarababy.in/products/baby-blankets-little-comforter-blush-blossom',
    },
  };

  document.querySelectorAll('.blanket-warmth-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const clickedWarmth = this.dataset.warmth;
      if (!clickedWarmth || clickedWarmth === selectedWarmth) return;

      const targetUrl = products?.[clickedWarmth]?.[design];
      if (!targetUrl) return;

      const url = new URL(targetUrl);
      url.searchParams.set('warmth', clickedWarmth);
      window.location.href = url.toString();
    });
  });
});